const PRODUCTS = "https://utihreyfingin.is/wp-json/wp/v2/product?per_page=100"
const PRODUCTMEDIA = "https://utihreyfingin.is/wp-json/wp/v2/media/"
// const _PRODUCTS = "https://reactdemo.local/wp-json/wp/v2/product"



export {PRODUCTS, PRODUCTMEDIA} 